/**
 * [数据统计tab]
 * @author: Fu Xiaochun
 * @date: 2021-09-24 
 */

import React, { useEffect, useState } from 'react';
import styles from './index.module.scss';
import PropTypes from 'prop-types';
import moment from 'moment';
import { XInput, XInputNum, XSelect, XDatePicker, XOKButton, XCancelButton, XTabNav } from '@/components/xqxc_ui';
import { SearchBox, SearchItem } from '@/components/Layout';
import { message, Table, DatePicker } from 'antd';
import * as apis from '@/apis/order/distributionorder';
import { tooltipStyle, tooltip, tooltipClick, cellWidth } from '@/components/TableCell';

function Statistics(props){

    const defaultStartTime = moment().subtract(6, 'days').format('YYYY-MM-DD 00:00:00');
    const defaultEndTime = moment().format('YYYY-MM-DD 23:59:59');

    const systype = process.env.TYPE == 'OC' ? 'COMPANY' : 'ADMIN';
    const [list, setList] = useState([]);
    const [createTimeStart, setCreateTimeStart] = useState(defaultStartTime);
    const [createTimeEnd, setCreateTimeEnd] = useState(defaultEndTime);
    const [company, setCompany] = useState({});
    const [type, setType] = useState({});
    // const [orderSourceEnum, setOrderSourceEnum] = useState([]);
    const [source, setSource] = useState({});
    // const [thirdPartyChannels, setThirdPartyChannels] = useState([]);
    const [thirdPartyChannel, setThirdPartyChannel] = useState({});
    const userAccountTypeEnum = [{code: 'USER', value: '个人账号'}, {code: 'ENTERPRISE', value: '企业账号'}];
    const [userAccountType, setUserAccountType] = useState({});
    const [userName, setUserName] = useState();
    const [reset, setReset] = useState();

    useEffect(()=>{
        onSearch();
    }, []);

    useEffect(()=>{
        reset && onSearch();
    }, [reset]);

    const onSearch = ()=>{
        let params = {
            type: type.code,
            orderSource: source.code,
            openApiCode: thirdPartyChannel.channelCode,
            userAccountType: userAccountType.code,
            userName,
            opId: company.companyId,
            createTimeStart,
            createTimeEnd,
        };
        apis.getStatisticsData(params).then(res=>{
            let dataList = res.result.map((v, index)=>{
                v.rowName = index ? '付款金额' : '订单数';
                return v;
            });
            setList(dataList);
        }).catch(err=>{
            message.error(err.message);
        });
    };

    const onReset = ()=>{
        setCreateTimeStart(defaultStartTime);
        setCreateTimeEnd(defaultEndTime);
        setCompany({});
        setType({});
        setSource({});
        setThirdPartyChannel({});
        setUserAccountType({});
        setUserName();
        setReset(Date.now());
    };

    const onStartDateChange = (data)=>{
        setCreateTimeStart(data);
        
    };

    const onEndDateChange = (data)=>{
        setCreateTimeEnd(data);
        
    };

    const disabledStartDate = (current)=>{
        let diffEnd = current.diff(createTimeEnd, 'seconds', true);
        let diffToday = current.diff(moment().format('YYYY-MM-DD 23:59:59'), 'seconds', true);

        if(createTimeEnd){
            if(diffEnd < -(86400 * 365) || diffEnd >= 0){
                return true;
            }else{
                return false;
            }
        }else{
            if(diffToday > 0){
                return true;
            }else{
                return false;
            }
        }
    };

    const disabledEndDate = (current)=>{
        let diffStart = current.diff(createTimeStart, 'seconds', true);
        let diffToday = current.diff(moment().format('YYYY-MM-DD 23:59:59'), 'seconds', true);
        let diffStart2Today = moment().diff(createTimeStart, 'seconds', true);
        
        if(createTimeStart){
            if(diffStart <= 0){
                return true;
            }else if( diffStart > (diffStart2Today + 86400) ){
                return true;
            }else if(diffStart > (86400 * 365)){
                return true;
            }else{
                return false;
            }
        }else{
            if(diffToday > (86400 * 0)){
                return true;
            }else{
                return false;
            }
        }
    };

    const onSourceChange = (val)=>{
        if(val.code !== 'OPEN_API'){
            setThirdPartyChannel({});
        }
    };

    const tableColumns = [
        {
            title: ' ',
            dataIndex: 'rowName',
            key: 'rowName',
            width: '80px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '全部',
            dataIndex: 'all',
            key: 'all',
            width: '80px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '待付款',
            dataIndex: 'paying',
            key: 'paying',
            width: '80px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '待发布',
            dataIndex: 'paid',
            key: 'paid',
            width: '80px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '待接单',
            dataIndex: 'published',
            key: 'published',
            width: '80px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '待取件',
            dataIndex: 'accepted',
            key: 'accepted',
            width: '80px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '配送中',
            dataIndex: 'delivering',
            key: 'delivering',
            width: '80px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '送达超时数',
            dataIndex: 'deliverTimeout',
            key: 'deliverTimeout',
            width: '80px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '已送达',
            dataIndex: 'delivered',
            key: 'delivered',
            width: '80px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '妥投异常',
            dataIndex: 'undelivered',
            key: 'undelivered',
            width: '80px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '已完成',
            dataIndex: 'finished',
            key: 'finished',
            width: '80px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '已取消',
            dataIndex: 'canceled',
            key: 'canceled',
            width: '80px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
    ];

    return (
        <div className={styles.flexBoxContainer}>
            <div className={styles.orderContainer} style={{overflow: 'hidden'}}>
                <SearchBox>
                    <SearchItem>
                        <XDatePicker
                            label='下单时间'
                            value={createTimeStart}
                            bindThis={setCreateTimeStart}
                            bindName='createTimeStart'
                            isFormat
                            showTime={false}
                            defaultTime='00:00:00'
                            onChange={onStartDateChange}
                            disabledDate={disabledStartDate}
                        />
                        <div className={styles.timeLine} />
                        <XDatePicker
                            style={{ marginRight: 20 }}
                            label=''
                            value={createTimeEnd}
                            bindThis={setCreateTimeEnd}
                            bindName='createTimeEnd'
                            isFormat
                            showTime={false}
                            defaultTime='23:59:59'
                            disabledDate={disabledEndDate}
                            onChange={onEndDateChange}
                        />
                    </SearchItem>
                    {
                        systype == 'ADMIN' ? <SearchItem>
                            <XSelect
                                label='运营公司'
                                placeholder='请选择运营公司'
                                renderData={props.companyList}
                                dataIndex='companyName'
                                keyIndex='companyId'
                                value={company.companyName}
                                showSearch={true}
                                bindThis={setCompany}
                                bindName='company'
                            />
                        </SearchItem> : null
                    }
                    <SearchItem>
                        <XSelect
                            label='订单类型'
                            placeholder='请选择订单类型'
                            renderData={props.OrderDeliveryTypeEnum}
                            dataIndex='value'
                            keyIndex='code'
                            value={type.value}
                            showSearch={true}
                            bindThis={setType}
                            bindName='type'
                        />
                    </SearchItem>
                    {systype == 'COMPANY' ? null : (
                        <>
                        <SearchItem>
                            <XSelect
                                label='订单来源'
                                placeholder='请选择'
                                renderData={props.orderSourceEnum}
                                dataIndex='value'
                                keyIndex='code'
                                value={source.value}
                                showSearch={true}
                                bindThis={setSource}
                                bindName='source'
                                onChange={onSourceChange}
                            />
                        </SearchItem>
                        {source.code == 'OPEN_API' 
                            ? <SearchItem>
                                <XSelect
                                    label='第三方渠道名称'
                                    placeholder='请选择'
                                    renderData={props.thirdPartyChannels}
                                    dataIndex='channelName'
                                    keyIndex='channelCode'
                                    value={thirdPartyChannel.channelName}
                                    showSearch={true}
                                    bindThis={setThirdPartyChannel}
                                    bindName='thirdPartyChannel'
                                />
                            </SearchItem>
                            : null
                        }
                        <SearchItem>
                            <XSelect
                                label='下单账号类型'
                                placeholder='请选择'
                                renderData={userAccountTypeEnum}
                                dataIndex='value'
                                keyIndex='code'
                                value={userAccountType.value}
                                showSearch={true}
                                bindThis={setUserAccountType}
                                bindName='userAccountType'
                            />
                        </SearchItem>
                        <SearchItem>
                            <XInput
                                label='下单账号'
                                placeholder='请输入'
                                value={userName}
                                bindThis={setUserName}
                                bindName='userName'
                            />
                        </SearchItem>
                        </>
                    )}
                    <SearchItem>
                        <XOKButton
                            label='查询'
                            onClick={onSearch}
                        />
                        <XCancelButton
                            label='重置'
                            onClick={onReset}
                        />
                    </SearchItem>
                </SearchBox>
            </div>
            <div className={styles.tableContainer} style={{marginTop: '20px'}}>
                <Table
                    rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
                    rowKey={record => record.rowName}
                    columns={tableColumns}
                    dataSource={list}
                    pagination={false}
                />
            </div>
        </div>
    );
}

Statistics.propTypes = {
    history: PropTypes.object, // 路由
    OrderDeliveryTypeEnum: PropTypes.array,
    orderSourceEnum: PropTypes.array,
    thirdPartyChannels: PropTypes.array,
    companyList: PropTypes.array
};

export default Statistics;